export const createMachineDirectionsViewStyles = ({ ui: { colors, space, type } }) => ({
	card: {
		gap: 14,
	},
	cardTitle: {
		...type.sectionTitle,
		color: colors.text,
	},
	field: {
		gap: space.xs,
	},
	fieldLabel: {
		...type.label,
		color: colors.textSecondary,
	},
	fieldValue: {
		...type.bodySmall,
		color: colors.text,
	},
	fieldEmpty: {
		color: colors.textSecondary,
	},
	yesNo: {
		alignSelf: 'flex-start',
	},
	multilineInput: {
		minHeight: 100,
		lineHeight: type.body.lineHeight,
		textAlignVertical: 'top',
	},
	actions: {
		flexDirection: 'row',
		gap: space.sm,
	},
	action: {
		flex: 1,
	},
	footnote: {
		...type.caption,
		color: colors.textSecondary,
		paddingHorizontal: space.xs,
	},
});
